// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__t7SnU","labelCaption":"Label_labelCaption__V2sor"};